// NotificacionPage.tsx
import { MRT_ColumnDef } from "material-react-table";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GeneralTable, SingleTableBoxScene } from "@/shared/components/ui";
import {
  useFetchGetNotificaciones,
  useFetchDeleteNotificacion,
} from "@/shared/actions";
import { MRT_ColumnFiltersState } from 'material-react-table';
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  useTableFilter,
  
} from "@/shared";
import { useUiConfirmModalStore } from "@/store/ui";
import { Notificacion } from "../../types";

import { useAuthStore } from "@/store/auth/auth.store"; 
import { useUserModulesStore } from "@/store/auth";       
import { SystemModulesEnum } from "@/auth/interfaces";
import { Outlet } from "react-router-dom";
import { toFilterParams } from "@/erp/controlcambios/servidores";

export default function NotificacionPage() {

   const user = useAuthStore((s) => s.user) as any; 
    const userModules = useUserModulesStore((s) => s.modules);  
    const isSuper = !!user?.is_superuser || !!user?.is_staff; 
    const tineAccesoAreacontrolAreas = userModules.includes(SystemModulesEnum.CONTROL_CAMBIOS_MAILS) 

  const returnUrl = ROUTER_PATHS.control_cambios.notificacionNav;
  const navigate = useNavigate();
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  const { pagination, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  // const { columnFilters, setColumnFilters } = useTableServerSideFiltering();
    const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);

  const {
    data: response,
    isLoading,
    isRefetching,
  } = useFetchGetNotificaciones({
    page: pageIndex,
    size: pageSize,
    ...toFilterParams(columnFilters),
  });

  const deleteNotificacion = useFetchDeleteNotificacion();

  const onEdit = (original: Notificacion) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar notificación",
      subtitle: "¿Está seguro que desea editar este registro?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrl}/editar/${original.notificacionId}`);
      },
    });
  };

  const onDelete = (origin: Notificacion) => {
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar notificación",
      subtitle: `¿Está seguro que desea eliminar la notificación "${origin.nombre}"? Esta acción no se puede deshacer.`,
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteNotificacion.mutate(origin.notificacionId!);
      },
    });
  };

  const columns = useMemo<MRT_ColumnDef<Notificacion>[]>(
    () => [
      {
        accessorKey: "nombre",
        header: "Nombre",
        size: 180,
        Cell: ({ row }) => row.original?.nombre || "N/A",
      },
      {
        accessorKey: "correo",
        header: "Correo",
        size: 220,
        Cell: ({ row }) => row.original?.correo || "N/A",
      },
      {
        accessorKey: "estado",
        header: "¿Está activo?",
        size: 140,
        filterVariant: "select",
        filterSelectOptions: [
          { text: "Activo", value: "true" },
          { text: "Inactivo", value: "false" },
        ],
        Cell: ({ row }) => (row.original?.estado ? "Activo" : "Inactivo"),
      },
    ],
    []
  );
  if(!isSuper || !tineAccesoAreacontrolAreas){
    return (
      <SingleTableBoxScene
        title={"Notificaciones de control de cambios"}
        urlRedirect={`${returnUrl}/crear`}
        py={2}
      >
        <GeneralTable<Notificacion>
          columns={columns}
          data={response?.data || []}
          isLoading={isLoading}
          isRefetching={isRefetching}
          enableGlobalFilter={false}
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          pagination={pagination}
          onPaging={setPagination}
          rowCount={response?.totalElements ?? 0}
          actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
          positionActionsColumn="first"
          canEdit={true}
          onEdit={onEdit}
          canDelete={true}
          onDelete={onDelete}
        />
      </SingleTableBoxScene>
    );
  }
    return <Outlet />;
}
